import { caption } from './radarCaption';
import { axis, centerGraph, scale, shape } from './radarShape';
import { IColumn, IOption, ISeries } from './radarTypes';
import { defaults, RANGE_MAX } from './radarUtil';
import { dimensionCompare } from '../../aiReportUtil';

export const radar = (columns: IColumn, series: ISeries[], opt: IOption = defaults) => {
    opt = Object.assign({}, defaults, opt);
    opt.chartSize = opt.size / opt.captionsPosition;

    const keys = Object.keys(columns).sort(dimensionCompare);
    const cols = keys.map((key, i, all) => ({
        key,
        caption: columns[key],
        value: +series[0][key] * (opt.rangeMax || RANGE_MAX),
        angle: (Math.PI * 2 * i) / all.length,
    }));

    const validColumns = cols.filter((col) => {
        return col.value !== 0;
    });
    const isValid = validColumns.length > 0;
    const groups = [];

    // 如果6个维度都是0 说明都没检测到，中心展示一团迷雾
    if (!isValid) {
        groups.push(centerGraph(keys.length));
    } else {
        // series
        groups.push(`
        <g>
            ${series.map(shape(cols, opt)).join('')}
        </g>
        `);

        // 坐标轴
        if (opt.axes) {
            groups.unshift(`
        <g>
            ${cols.map(axis(opt)).join('')}
        </g>
        `);
        }

        // 放射状参考线
        if (opt.scales > 0) {
            const scales = [];
            for (let i = opt.scales; i > 0; i--) {
                scales.push(scale(opt, cols, i));
            }
            groups.unshift(`
        <g>
            ${scales.join('')}
        </g>
        `);
        }
    }

    // 标题
    if (opt.captions) {
        groups.push(`
        <g>
            ${cols.map(caption(opt)).join('')}
        </g>
        `);
    }

    const deltaX = opt.size / 2;
    let deltaY = opt.size / 2 + 5;
    const len = Object.keys(columns).length;
    switch (len) {
        case 3:
            deltaY += 0;
            break;
    }

    return `
    <g transform="translate(${deltaX.toFixed(4)},${deltaY.toFixed(4)})">
        ${groups.join('')}
    </g>
    `;
};
